'use client';

import { useState } from 'react';
import Link from 'next/link';
import MenuButtonLink from './order/MenuButtonLink';
import CartButtonLink from './order/CartButtonLink';
import Image from 'next/image';
import Logo from '../../public/assets/logo_op.png';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/contact', label: 'Contact Us' },
  ];

  return (
    <nav className=" bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="rounded-bl-2xl rounded-br-2xl px-3 flex content-center">
          <Link href="/" className="flex items-center space-x-2">
            <Image src={Logo} alt="Jayouz's logo" width={120} height={120} className="w-16 h-16" />
          </Link>
        </div>
        <div className="px-4 sm:px-6 lg:px-8 print:hidden">
          <div className="flex justify-end items-center">
            {/* Logo */}

            {/* Desktop Navigation */}
            <div className="me-6 hidden md:block">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  href={item.path}
                  className="px-3 py-2 rounded-md transition-colors duration-200 font-medium text-gray-700 hover:text-orange-600">
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Order Now Button */}
            <div className="flex items-center gap-2">
              <MenuButtonLink />
              <CartButtonLink />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t flex flex-col gap-3">
            <MenuButtonLink onClick={() => setIsOpen(false)} />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
